import { NonOptional } from '@tanium/coreui-utils';
import { SELECTION_MODE_INCLUDE } from '@tanium/react-use-selection';
import { Id } from '../../types/Id';
import {
  StackedRibbonListMinimalProps,
  StackedRibbonListProps,
} from '../../types/StackedRibbonListComponentTypes';

type UseStackedRibbonListReturnType<TId extends Id, TItem> = NonOptional<
  StackedRibbonListMinimalProps<TId, TItem>
>;

export const useStackedRibbonList = <TId extends Id, TItem>(
  props: StackedRibbonListProps<TId, TItem>,
): UseStackedRibbonListReturnType<TId, TItem> => {
  const {
    actions,
    actionsVerticalAlignment,
    checkboxVerticalAlignment,
    columns,
    dataGetter,
    disclosureVerticalAlignment,
    enableRowHighlight = true,
    initialScrollOffset,
    isIdEmphasized,
    isItemLoaded,
    isLoading,
    isError,
    isSelectionEnabled,
    itemCount,
    itemIdGetter,
    onScroll,
    onSortChange,
    selectionTooltipContent,
    sort,
    totalItemCount,
    verticalAlignment,
    // selection props
    isSelectable,
    enableSelectAll = true,
    selection = new Set([]),
    selectionMode = SELECTION_MODE_INCLUDE,
    onSelectionChange,
    // expansion props
    expandableContent,
    isExpandable,
    defaultExpansion,
    defaultExpansionMode,
    expansion,
    expansionMode,
    onExpansionChange,
    hideExpansionDisclosure,
    enableExpandAll,
    onRowClick,
  } = props;

  return {
    actions,
    actionsVerticalAlignment,
    checkboxVerticalAlignment,
    columns,
    disclosureVerticalAlignment,
    dataGetter,
    enableRowHighlight,
    initialScrollOffset,
    isIdEmphasized,
    isItemLoaded,
    isLoading,
    isError,
    isSelectionEnabled,
    itemCount,
    itemIdGetter,
    onSortChange,
    selectionTooltipContent,
    sort,
    onScroll,
    totalItemCount,
    verticalAlignment,
    // selection props
    isSelectable,
    enableSelectAll,
    selection,
    selectionMode,
    onSelectionChange,
    // expansion props
    expandableContent,
    isExpandable,
    defaultExpansion,
    defaultExpansionMode,
    expansion,
    expansionMode,
    onExpansionChange,
    hideExpansionDisclosure,
    enableExpandAll,
    onRowClick,
  };
};
